<template>
  <div v-if="!!editingWorker && ($hasRoleStartsWith(role, ['Admin', 'Lead']) || editingWorker.id === currentWorkerId)">
    <div class="row">
      <div class="col-md-8">
        <h1>Delavec {{ editingWorker.fullName }}</h1>
      </div>
    </div>

    <div class="row mb-3 mt-3">
      <div class="col-md-8">
        <div class="row mb-3" v-if="!editingWorker.isNew">
          <label class="form-check-label col-sm-4" for="is-absent">Odsoten</label>
          <div class="col-sm-8">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="is-absent"
                v-model="editingWorker.isAbsent"
                disabled="true"
              />

              <button
                class="btn btn-sm btn-success"
                type="button"
                v-show="!editingWorker.isAbsent && !isNew"
                @click="changeWorkerAbsenceAsync"
                :disabled="!$hasRoleStartsWith(role, ['Admin', 'Lead'])"
              >
                Spremeni v odsoten
              </button>
              <button
                class="btn btn-sm btn-outline-success"
                type="button"
                v-show="editingWorker.isAbsent && !isNew"
                @click="changeWorkerAbsenceAsync"
                :disabled="!$hasRoleStartsWith(role, ['Admin', 'Lead'])"
              >
                Spremeni v prisoten
              </button>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-form-label col-sm-4">Ime</label>
          <div class="col-sm-8">
            <input
              class="form-control"
              type="text"
              v-model="editingWorker.firstName"
              :disabled="!$hasRoleStartsWith(role, ['Admin', 'Lead'])"
              required
            />
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-form-label col-sm-4">Priimek</label>
          <div class="col-sm-8">
            <input
              class="form-control"
              type="text"
              v-model="editingWorker.lastName"
              :disabled="!$hasRoleStartsWith(role, ['Admin', 'Lead'])"
              required
            />
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-form-label col-sm-4">Telefon</label>
          <div class="col-sm-8">
            <input
              class="form-control"
              type="text"
              v-model="editingWorker.phone"
              :disabled="!$hasRoleStartsWith(role, ['Admin', 'Lead'])"
            />
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-form-label col-sm-4">Email</label>
          <div class="col-sm-8">
            <input
              class="form-control"
              type="email"
              v-model="editingWorker.email"
              :disabled="!$hasRoleStartsWith(role, ['Admin', 'Lead'])"
            />
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-form-label col-sm-4">Št. certifikata</label>
          <div class="col-sm-8">
            <input
              class="form-control"
              type="text"
              v-model="editingWorker.certificationNumber"
              :disabled="!$hasRoleStartsWith(role, ['Admin', 'Lead'])"
            />
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-form-label col-sm-4">Vozilo</label>
          <div class="col-sm-8">
            <input class="form-control" type="text" v-model="editingWorker.vehicleRegistrationNumber" readonly />
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-form-label col-sm-4">Partner</label>
          <div class="col-sm-8">
            <SelectEntity
              :required="true"
              apiEntity="DropDown/Partners"
              v-model="editingWorker.partnerID"
              :canChange="$hasRoleStartsWith(role, ['Admin', 'Lead'])"
            />
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-form-label col-sm-4">Podpisnik za preskus tesnosti</label>
          <div class="col-sm-8">
            <SelectEntity
              apiEntity="DropDown/Workers"
              v-model="editingWorker.leakageFormSignerID"
              :canChange="$hasRoleStartsWith(role, ['Admin', 'Lead'])"
            />
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-form-label col-sm-4">Lat (45 do 47)</label>
          <div class="col-sm-4">
            <input
              class="form-control"
              pattern="[0-9.]+"
              type="number"
              step="any"
              v-model="editingWorker.lat"
              :disabled="!$hasRoleStartsWith(role, ['Admin', 'Lead'])"
            />
          </div>
        </div>
        <div class="row mb-3">
          <label class="col-form-label col-sm-4">Lng (13 do 17)</label>
          <div class="col-sm-4">
            <input
              class="form-control"
              pattern="[0-9.]+"
              type="number"
              step="any"
              v-model="editingWorker.lng"
              :disabled="!$hasRoleStartsWith(role, ['Admin', 'Lead'])"
            />
          </div>
        </div>

        <div class="row mb-3" v-if="!editingWorker.isNew">
          <label class="form-check-label col-sm-4" for="is-active">Aktiven (ni aktiven pomeni zbrisan)</label>
          <div class="col-sm-8">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="is-active"
                v-model="editingWorker.isActive"
                :disabled="!$hasRoleStartsWith(role, ['Admin', 'Lead'])"
              />
            </div>
          </div>
        </div>

        <div class="row" v-show="!editingWorker.isNew">
          <div class="col">
            <input type="file" @change="chooseFile" v-show="$hasRoleStartsWith(role, ['Admin', 'Lead'])" />
          </div>
          <div class="col shadow-lg p-3 mb-5 bg-white rounded" v-show="hasImage">
            <img ref="imageEl" />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card mb-3" v-if="!editingWorker.isNew && !editWarehouses">
          <div class="card-body">
            <h5 class="card-title">
              Skladišča <button class="btn btn-sm btn-outline-info" @click="editWarehouses = true">Urejaj</button>
            </h5>
            <ul>
              <li v-for="w in editingWorker.warehouses" class="mt-1">
                <strong v-show="w.isPrimary === true">{{ w.name }}</strong>
                <span v-show="w.isPrimary === false">{{ w.name }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="card mb-3" v-if="!editingWorker.isNew && editWarehouses">
          <div class="card-body">
            <h5 class="card-title">Primarno skladišče</h5>
            <SelectEntity
              :required="true"
              apiEntity="Dropdown/Warehouses"
              v-model="editingWorker.primaryWarehouseId"
              @selected="changePrimaryWarehouse"
              :canChange="$hasRoleStartsWith(role, ['Admin', 'Lead'])"
            />
            <h5 class="card-title">Sekundarna skladišča</h5>
            <ul>
              <li v-for="w in editingWorker.warehouses.filter((w) => w.isPrimary === false)" class="mt-1">
                {{ w.name }}
                <button
                  class="btn btn-sm btn-outline-danger"
                  @click="editingWorker.warehouses.splice(editingWorker.warehouses.indexOf(w), 1)"
                >
                  Odstrani
                </button>
              </li>
            </ul>

            <p class="card-text">Za dodajanje moraš skladišče najprej izbrati in nato klikniti "Dodaj".</p>
            <SelectEntity
              apiEntity="Dropdown/Warehouses"
              v-model="warehouseToAddId"
              @selected="
                (e) => {
                  $log(e)
                  warehouseToAdd = { id: e.id, name: e.text, isPrimary: false }
                }
              "
              :canChange="$hasRoleStartsWith(role, ['Admin', 'Lead'])"
            />
            <button
              class="btn btn-sm btn-primary"
              type="button"
              :disabled="!warehouseToAdd || editingWorker.warehouses.some((w) => w.id === warehouseToAdd.id)"
              @click="addWarehouse"
            >
              Dodaj
            </button>
          </div>
        </div>
        <ServiceOrdersCard
          class="card mb-3"
          v-if="!editingWorker.isNew && editingWorker.id"
          title="Delovni nalogi"
          subTitle="Prevzeti ali v delu"
          :ownerID="editingWorker.id"
          statuses="Accepted,InProgress"
          :itemsPerPage="100"
        />
        <WarehouseTransfersCard
          class="card mb-3"
          v-if="
            !editingWorker.isNew &&
            !!editingWorker.primaryWarehouseId &&
            editingWorker.primaryWarehouseId !== $EMPTY_GUID
          "
          titleText="Primarno skladišče"
          statuses="New,MovementOrder"
          :toWarehouseID="editingWorker.primaryWarehouseId"
          :itemsPerPage="500"
        />
      </div>
    </div>

    <RequiredWarning v-show="!isValid" />

    <div class="row mb-5">
      <div class="col-2 text-start"></div>
      <div class="col-10 text-end">
        <button class="btn btn-outline-secondary me-3" type="button" @click="$router.push({ name: 'Workers' })">
          Prekliči
        </button>
        <button
          class="btn btn-success btn-lg me-3"
          type="button"
          @click="saveWorkerAsync"
          :disabled="!$hasRoleStartsWith(role, ['Admin', 'Lead']) || !isValid"
        >
          Shrani
        </button>
      </div>
    </div>

    <div v-if="!editingWorker.isNew">
      <div class="mt-2 mb-3 p-3 bg-light rounded">
        <div class="row mb-3">
          <DateTimeInput class="col-md-3" label-text="Od" v-model="from" />
          <DateTimeInput class="col-md-3" label-text="Do" v-model="to" />
          <div class="form-check col-md-3">
            <input class="form-check-input" type="checkbox" v-model="includeFromToWork" id="fromToWork" />
            <label class="form-check-label" for="fromToWork">Tudi prevoz na/iz dela</label>
          </div>
          <div class="col-md-3 d-flex align-items-center gap-3">
            <a href="#" @click.prevent="setPeriodAsync('thisMonth')" role="button">Mesec</a>
            <a href="#" @click.prevent="setPeriodAsync('thisWeek')" role="button">Teden</a>
            <a href="#" @click.prevent="setPeriodAsync('previousMonth')" role="button">Prejšnji&nbsp;mesec</a>
            <button class="btn btn-primary ms-auto" type="button" @click="loadReportTimesTransportsAsync">
              Prikaži
            </button>
          </div>
        </div>
      </div>

      <div class="row col">
        <h3>Odprti nalogi</h3>
        <span
          >Št na novo odprtih nalogov v izbranem obdobju:
          <span class="badge bg-primary">{{ workerStats?.newOrders?.openedServiceOrders }}</span
          >.
        </span>
      </div>

      <div class="row col" v-if="workerStats?.levels?.length > 0 && $hasRoleStartsWith(role, ['Admin', 'Lead'])">
        <h3>Ocene</h3>
        <p>
          Skupno število dodeljenih servisnih nalogov v izbranem obdobju:
          <span class="badge bg-primary">{{ workerStats.levels.length }}</span
          >.
        </p>

        <p>
          Težavnost izvedbe (povprečje za vse, ki imajo oceno):
          <span class="badge bg-secondary">{{ levelCounts.difficultyLevel?.toFixed(1) }}</span
          >.
        </p>
        <p>
          Kvaliteta izvedbe (povprečje za vse, ki imajo oceno):
          <span class="badge bg-secondary">{{ levelCounts.quality?.toFixed(1) }}</span
          >.
        </p>

        <p>
          Pripravljenost na delo izven delovnega časa (DA):
          <span class="badge bg-success">{{ levelCounts.extendedHours2 }}</span
          >, (NE): <span class="badge bg-danger">{{ levelCounts.extendedHours1 }}</span
          >.
        </p>
        <p>
          Skrb za minimalno zalogo (DA): <span class="badge bg-success">{{ levelCounts.minStockCare2 }}</span
          >, (NE): <span class="badge bg-warning text-dark">{{ levelCounts.minStockCare1 }}</span
          >.
        </p>
        <p>
          Popolni popis (DA): <span class="badge bg-success">{{ levelCounts.fullList2 }}</span
          >, (NE): <span class="badge bg-warning text-dark">{{ levelCounts.fullList1 }}</span>
        </p>
        <p>
          Mentorstvo (DA): <span class="badge bg-success">{{ levelCounts.mentoring2 }}</span
          >, (NE): <span class="badge bg-danger">{{ levelCounts.mentoring1 }}</span
          >.
        </p>
        <p>
          Nalog je potreboval sanacijo (DA): <span class="badge bg-danger">{{ levelCounts.dateRemediation2 }}</span
          >, (NE): <span class="badge bg-success">{{ levelCounts.dateRemediation2 }}</span
          >.
        </p>
      </div>

      <div v-if="allDays?.length > 0" class="row col">
        <h3>Opravljeno delo</h3>
        <p v-show="totalDurationMin.shown > 1">
          Vse prikazane: <span class="badge bg-primary">{{ totalDurationHrs.shown }} ur</span>.
        </p>
        <p v-show="totalDurationMin.service > 1">
          Na delu: <span class="badge bg-success">{{ totalDurationHrs.service }} ur</span>.
        </p>
        <p v-show="totalDurationMin.transport > 1">
          Na poti: <span class="badge bg-secondary">{{ totalDurationHrs.transport }} ur</span>.
        </p>
        <p v-show="totalDurationMin.meeting > 1">
          Sestanek: <span class="badge bg-info text-dark">{{ totalDurationHrs.meeting }} ur</span>.
        </p>
        <p v-show="totalDurationMin.shoppingWarehouseOffice > 1">
          Nabava in skladišče:
          <span class="badge bg-warning text-dark">{{ totalDurationHrs.shoppingWarehouseOffice }} ur</span>.
        </p>
      </div>

      <div v-for="day in allDays" :key="day.key" class="card mb-3">
        <div class="card-header py-2">
          <strong>{{ day.date.format("D.M. ddd") }}</strong>
        </div>
        <div class="card-body py-2">
          <div class="row">
            <div class="col-md-7">
              <div v-if="enteredByDay[day.key]?.length > 0" class="table-responsive">
                <table class="table table-stripped table-sm table-hover mb-0">
                  <thead>
                    <tr>
                      <th scope="col">Čas</th>
                      <th scope="col">Trajanje</th>
                      <th scope="col">Tip / vrsta</th>
                      <th scope="col">Objekt</th>
                      <th scope="col">Pot</th>
                      <th scope="col">Komentar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(tr, idx) in enteredByDay[day.key]"
                      :class="{
                        'bg-danger-light':
                          idx > 0 &&
                          $dayjs
                            .utc(tr.startDateTime)
                            .add(2, 'minutes')
                            .isBefore($dayjs.utc(enteredByDay[day.key][idx - 1]?.endDateTime)),
                      }"
                    >
                      <td>
                        {{ $dayjs.utc(tr.startDateTime).local().format("HH:mm") }} –
                        {{ $dayjs.utc(tr.endDateTime).local().format("HH:mm") }}
                      </td>
                      <td>{{ $fmtMin(tr.durationMin) }}</td>
                      <td>
                        <span v-show="tr.type === 'Transport'">
                          <a @click="selectOrder(tr)" role="button" style="text-decoration: underline">Prevoz</a>
                        </span>
                        <span v-show="tr.type === 'Pause'">Pavza</span>
                        <span v-show="tr.type === 'Work' && tr.orderType !== 'Internal'">
                          <button class="btn btn-sm btn-success" @click="selectOrder(tr)">
                            {{ types.get(tr.orderType) }} nalog
                          </button>
                        </span>
                        <span v-show="tr.type === 'Work' && tr.orderType === 'Internal'">
                          <a @click="selectOrder(tr)" role="button" style="text-decoration: underline">{{
                            internalOrderTypes.get(tr.internalType)
                          }}</a>
                        </span>
                        {{ tr.internalType }}
                      </td>
                      <td>{{ tr.serviceFacility }}</td>
                      <td>
                        <span v-show="tr.startLat">
                          <a
                            :href="'http://www.google.com/maps/place/' + tr.startLat + ',' + tr.startLng"
                            target="_blank"
                            >Začetek</a
                          >
                        </span>
                        <span v-show="tr.personalKilometers > 0"> {{ tr.personalKilometers }} km </span>
                        <br v-show="tr.startLat && tr.endLat" />
                        <span v-if="tr.endLat">
                          <a :href="'http://www.google.com/maps/place/' + tr.endLat + ',' + tr.endLng" target="_blank"
                            >Konec</a
                          >
                        </span>
                        <span v-else> {{ tr.relation }} </span>
                        {{ tr.vehicle }}
                        <br v-show="tr.isPassenger === true" />{{ tr.isPassenger === true ? "Sovoznik" : "" }}
                      </td>
                      <td>
                        {{ tr.comments }} {{ tr.internalComments }} {{ tr.internalSubject }}
                        <span
                          class="badge bg-warning text-dark"
                          v-show="tr.internalType === 'WarehouseOrOffice' && tr.durationMin > 10"
                          >&gt;10min</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-5">
              <table class="table table-stripped table-sm table-hover mb-0" v-if="vehicleStops[day.key]?.length > 0">
                <thead>
                  <tr>
                    <th>Od</th>
                    <th>Vožnja</th>
                    <th>Postanek</th>
                    <th>Do</th>
                    <th>Lokacija</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="stop in vehicleStops[day.key]" :key="stop.cas">
                    <td class="text-nowrap">{{ $dayjs(stop.cas).format("HH:mm") }}</td>
                    <td class="text-nowrap">
                      {{ Math.round(stop.distanceMeters / 1000) + " km" }}
                      <small class="text-muted">{{ $fmtSec(stop.travelToStopDurationSeconds) }}</small>
                    </td>
                    <td class="text-nowrap">{{ $fmtSec(stop.durationSeconds) }}</td>
                    <td class="text-nowrap">{{ $dayjs(stop.konec).format("HH:mm") }}</td>
                    <td>
                      <span v-if="stop.matchedLocation" class="text-success fw-semibold">{{
                        stop.matchedLocation
                      }}</span>
                      <span v-else>{{ stop.lokacija }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <hr />
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import {
  useAuth,
  authState,
  isAuthenticated,
  user,
  role,
  showMessageToWorker,
  currentWorkerId,
} from "../composition-api/useAuth"

import { setError, startLoading, stopLoading, setSuccess, setWarning } from "../components/Notification"
import { getEntityAsync, getVehicleStopsAsync } from "../api"
import { DATETIME_FOR_LOCAL_INPUT, EMPTY_GUID } from "../utils/constants"
import { useEnums } from "../composition-api/useEnums"
import ServiceOrdersCard from "../components/ServiceOrdersCard.vue"
import WarehouseTransfersCard from "../components/WarehouseTransfersCard.vue"

defineOptions({ name: "WorkerEdit" })

defineProps({
  width: {
    type: Number,
    default: 640,
  },
  height: {
    type: Number,
    default: 400,
  },
})

const route = VueRouter.useRoute()
const router = VueRouter.useRouter()
const { fetchAuthAsync } = useAuth()
const { internalOrderTypes, types, loadEnumsAsync } = useEnums()

const imageEl = ref(null)
const hasImage = ref(false)
const hasNewImage = ref(false)

const editWarehouses = ref(false)

const editingWorker = ref()
const editingWorkerTimes = ref([])
const workerStats = ref()
const vehicleStops = ref({}) // { "D.M.YYYY": [{ cas, wy, wx, ... }, ...] }

const enteredByDay = computed(() => {
  const map = {}
  for (const entry of editingWorkerTimes.value) {
    const day = dayjs.utc(entry.startDateTime).format("D.M.YYYY")
    if (!map[day]) map[day] = []
    map[day].push(entry)
  }
  return map
})

const allDays = computed(() => {
  const daySet = new Set()
  for (const day of Object.keys(enteredByDay.value)) daySet.add(day)
  for (const day of Object.keys(vehicleStops.value)) {
    if (vehicleStops.value[day]?.length > 0) daySet.add(day)
  }
  return [...daySet]
    .sort((a, b) => {
      const [dA, mA, yA] = a.split(".").map(Number)
      const [dB, mB, yB] = b.split(".").map(Number)
      return yA - yB || mA - mB || dA - dB
    })
    .map((key) => {
      const [d, m, y] = key.split(".").map(Number)
      return { key, date: dayjs(`${y}-${m}-${d}`) }
    })
})

const warehouseToAdd = ref()
const warehouseToAddId = ref("")

// a v-on value is parsed as statements only while it contains a `;`, otherwise as a single
// expression - so multi-statement handlers live here, where formatting cannot invalidate them
const addWarehouse = () => {
  editingWorker.value.warehouses.push({ ...warehouseToAdd.value })
  warehouseToAdd.value = null
  warehouseToAddId.value = ""
}

const from = ref(dayjs.utc().startOf("month").subtract(1, "month").format(DATETIME_FOR_LOCAL_INPUT))
const to = ref(dayjs.utc().endOf("month").subtract(1, "month").format(DATETIME_FOR_LOCAL_INPUT))
const includeFromToWork = ref(false)

const setPeriodAsync = async (period) => {
  if (period === "thisMonth") {
    from.value = dayjs.utc().startOf("month").format(DATETIME_FOR_LOCAL_INPUT)
    to.value = dayjs.utc().endOf("month").format(DATETIME_FOR_LOCAL_INPUT)
  } else if (period === "thisWeek") {
    from.value = dayjs.utc().subtract(7, "day").startOf("day").format(DATETIME_FOR_LOCAL_INPUT)
    to.value = dayjs.utc().endOf("day").format(DATETIME_FOR_LOCAL_INPUT)
  } else if (period === "previousMonth") {
    from.value = dayjs.utc().startOf("month").subtract(1, "month").format(DATETIME_FOR_LOCAL_INPUT)
    to.value = dayjs.utc().endOf("month").subtract(1, "month").format(DATETIME_FOR_LOCAL_INPUT)
  }
  await loadReportTimesTransportsAsync()
}

const selectOrder = (reportRow) => {
  let routeData = null
  if (reportRow.productionOrderID) {
    routeData = router.resolve({ name: "ProductionOrder", params: { workOrderId: reportRow.productionOrderID } })
  } else if (reportRow.serviceOrderID) {
    routeData = router.resolve({ name: "ServiceOrder", params: { workOrderId: reportRow.serviceOrderID } })
  } else if (reportRow.internalOrderID) {
    routeData = router.resolve({ name: "InternalOrder", params: { workOrderId: reportRow.internalOrderID } })
  } else {
    return
  }
  window.open(routeData.href, "_blank")
}

const getWorkerAsync = async (id) => {
  if (!id) return null
  startLoading("getWorkerAsync")
  try {
    const raw = await fetchAuthAsync(`${AZURE_URI}/Worker/${id}`, "GET")
    if (raw?.status !== "ok") {
      throw raw
    }
    if (!raw.result) {
      throw raw
    }
    editingWorker.value = raw.result
    editingWorker.value.isNew = id === "new"
    if (editingWorker.value.isNew) {
      stopLoading("getWorkerAsync")
      return
    }

    const base64 = await fetchAuthAsync(`${AZURE_URI}/WorkerSignature/${id}`, "GET")
    if (imageEl.value) {
      if (typeof base64 === "string" && base64.startsWith("data:image")) {
        imageEl.value.src = base64
        hasImage.value = true
      } else {
        imageEl.value.src = null
        hasImage.value = false
      }
    }
  } catch (e) {
    setError(e)
  }
  stopLoading("getWorkerAsync")
}

const saveWorkerAsync = async (patch = false) => {
  startLoading("saveWorkerAsync")
  try {
    const raw = await fetchAuthAsync(
      `${AZURE_URI}/Workers`,
      patch === true ? "PATCH" : isNew.value ? "POST" : "PUT",
      editingWorker.value,
    )
    if (raw?.status !== "ok") {
      throw raw
    }

    if (editingWorker.value.isNew) {
      console.log("new worker saved", raw.result)
      stopLoading("saveWorkerAsync")
      setSuccess("Shranjeno.")
      router.push({ name: `WorkerEdit`, params: { workerId: editingWorker.value.id, keepMessages: true } })
      return
    }
    console.log("worker saved", raw.result)
    if (hasNewImage.value) {
      console.log("saving image")
      const raw1 = await fetchAuthAsync(
        `${AZURE_URI}/WorkerSignature/${route.params.workerId}`,
        "PUT",
        imageEl.value.src,
      )
      if (raw1?.status !== "ok") {
        setWarning("Slika ni bila shranjena.")
      }
    }
    setSuccess("Shranjeno. " + raw?.message)
    await getWorkerAsync(route.params.workerId)
  } catch (e) {
    setError(e)
  }
  editWarehouses.value = false
  stopLoading("saveWorkerAsync")
}

const changeWorkerAbsenceAsync = async () => {
  startLoading("saveWorkerAsync")
  editingWorker.value.isAbsent = !editingWorker.value.isAbsent
  await saveWorkerAsync(true) // PATCH
}

const chooseFile = (e) => {
  const file = e.target.files[0]
  if (file?.type !== "image/jpeg") {
    console.log(file?.type)
    setError("Datoteka mora biti tipa jpg.")
  } else {
    const reader = new FileReader()
    reader.onload = (e) => {
      // editingWorker.value.signatureImageBase64 = e.target.result
      imageEl.value.src = e.target.result
      hasImage.value = e.target.result?.length > 5
      hasNewImage.value = hasImage.value
    }
    reader.readAsDataURL(file)
  }
}

const totalDurationMin = ref({ shown: 0, service: 0, transport: 0, meeting: 0, shoppingWarehouseOffice: 0 })

const totalDurationHrs = computed(() => {
  return {
    shown: Math.ceil(totalDurationMin.value.shown / 60),
    service: Math.ceil(totalDurationMin.value.service / 60),
    transport: Math.ceil(totalDurationMin.value.transport / 60),
    meeting: Math.ceil(totalDurationMin.value.meeting / 60),
    shoppingWarehouseOffice: Math.ceil(totalDurationMin.value.shoppingWarehouseOffice / 60),
  }
})

const levelCounts = computed(() => {
  if (!workerStats.value?.levels || !Array.isArray(workerStats.value.levels)) {
    return {
      dateRemediation: 0,
      quality: 0,
      extendedHours: 0,
      minStockCare: 0,
      fullList: 0,
      difficultyLevel: 0,
      mentoring: 0,
    }
  }

  // Calculate averages for difficulty and quality
  const difficultyValues = workerStats.value.levels.map((level) => level.difficultyLevel).filter((val) => val > 0)

  const qualityValues = workerStats.value.levels.map((level) => level.qualityLevel).filter((val) => val > 0)

  return {
    difficultyLevel:
      difficultyValues.length > 0 ? difficultyValues.reduce((acc, val) => acc + val, 0) / difficultyValues.length : 0,
    quality: qualityValues.length > 0 ? qualityValues.reduce((acc, val) => acc + val, 0) / qualityValues.length : 0,
    extendedHours2: workerStats.value.levels.filter((level) => level.extendedHoursLevel === 2).length,
    minStockCare2: workerStats.value.levels.filter((level) => level.minStockCareLevel === 2).length,
    fullList2: workerStats.value.levels.filter((level) => level.fullListLevel === 2).length,
    dateRemediation2: workerStats.value.levels.filter((level) => level.dateRemediation === 2).length,
    mentoring2: workerStats.value.levels.filter((level) => level.mentoringLevel === 2).length,
    extendedHours1: workerStats.value.levels.filter((level) => level.extendedHoursLevel === 1).length,
    minStockCare1: workerStats.value.levels.filter((level) => level.minStockCareLevel === 1).length,
    fullList1: workerStats.value.levels.filter((level) => level.fullListLevel === 1).length,
    dateRemediation1: workerStats.value.levels.filter((level) => level.dateRemediation === 1).length,
    mentoring1: workerStats.value.levels.filter((level) => level.mentoringLevel === 1).length,
  }
})

const isNew = computed(() => route.params.workerId === "new")

const isValid = computed(
  () =>
    editingWorker.value?.firstName?.length > 0 &&
    editingWorker.value?.lastName?.length > 0 &&
    ((editingWorker.value?.primaryWarehouseId?.length === 36 &&
      editingWorker.value?.primaryWarehouseId !== EMPTY_GUID) ||
      editingWorker.value?.isNew ||
      editingWorker.value?.isAbsent ||
      !editingWorker.value?.isActive) &&
    editingWorker.value?.partnerID?.length === 36,
)

const changePrimaryWarehouse = (e) => {
  editingWorker.value.warehouses.forEach((wh) => (wh.isPrimary = false))
  const existingWarehouse = editingWorker.value.warehouses.find((w) => w.id === e.id)
  if (existingWarehouse) {
    existingWarehouse.isPrimary = true
  } else {
    editingWorker.value.warehouses.push({ id: e.id, name: e.text, isPrimary: true })
  }
}

const loadWorkerAsync = async () => {
  console.log("loadWorkerAsync")
  await getWorkerAsync(route.params.workerId)
  await loadReportTimesTransportsAsync()
}

const loadReportTimesTransportsAsync = async () => {
  console.log("loadReportTimesTransportsAsync")
  if (editingWorker.value?.isNew) return

  if (!from.value || !to.value) {
    editingWorkerTimes.value = []
    workerStats.value = {}
    return
  }

  const fromDate = dayjs.utc(from.value).format("YYYY-MM-DD")
  const toDate = dayjs.utc(to.value).format("YYYY-MM-DD")

  const workerVehicle = editingWorker.value?.vehicleRegistrationNumber

  // Load times, stats, and vehicle stops for worker's current vehicle — all in parallel
  const [timesResult, statsResult, initialStopsData] = await Promise.all([
    getEntityAsync(
      fetchAuthAsync,
      "Report/WorkerTimeTransport",
      route.params.workerId,
      `?from=${from.value}&to=${to.value}&fromToWork=${includeFromToWork.value}`,
    ),
    getEntityAsync(fetchAuthAsync, "Report/WorkerStats", route.params.workerId, `?from=${from.value}&to=${to.value}`),
    workerVehicle ? getVehicleStopsAsync(fetchAuthAsync, workerVehicle, fromDate, toDate) : Promise.resolve([]),
  ])

  editingWorkerTimes.value = timesResult ?? []
  workerStats.value = statsResult ?? {}

  if (!editingWorkerTimes.value) {
    console.error("editingWorkerTimes null")
    return
  }

  // Sort and store stops data by day
  const gpsByDay = {}
  for (const stop of initialStopsData) {
    const day = dayjs.utc(stop.cas).format("D.M.YYYY")
    if (!gpsByDay[day]) gpsByDay[day] = []
    gpsByDay[day].push(stop)
  }
  for (const day of Object.keys(gpsByDay)) {
    gpsByDay[day].sort((a, b) => new Date(a.cas) - new Date(b.cas))
  }
  vehicleStops.value = gpsByDay

  totalDurationMin.value.shown = editingWorkerTimes.value.reduce((acc, o) => acc + o.durationMin, 0)
  totalDurationMin.value.service = editingWorkerTimes.value
    .filter((r) => r.type === "Work" && r.orderType !== "Internal")
    .reduce((acc, o) => acc + o.durationMin, 0)
  totalDurationMin.value.transport = editingWorkerTimes.value
    .filter((r) => r.type === "Transport")
    .reduce((acc, o) => acc + o.durationMin, 0)
  totalDurationMin.value.meeting = editingWorkerTimes.value
    .filter((r) => r.internalType === "Meeting")
    .reduce((acc, o) => acc + o.durationMin, 0)
  totalDurationMin.value.shoppingWarehouseOffice = editingWorkerTimes.value
    .filter((r) => r.internalType === "MaterialShopping" || r.internalType === "WarehouseOrOffice")
    .reduce((acc, o) => acc + o.durationMin, 0)
}

watch(
  () => route.params.workerId,
  () => loadWorkerAsync(),
)

onMounted(async () => {
  console.log("onMounted")
  await loadEnumsAsync()
  await loadWorkerAsync()
})
</script>
